import React from 'react';
import { archive } from '../../content/site';
import { ExpandBar } from './ExpandBar';
import { expandOnClick } from './expandable';
import styles from './Apps.module.css';

interface ArchiveProps {
    expanded: boolean;
    compact: boolean;
    onToggle: () => void;
}

/** 지나온 프로젝트를 표지로 걸어둔 패널. 누르면 펼쳐져 설명까지 보여준다 */
export const Archive: React.FC<ArchiveProps> = ({ expanded, compact, onToggle }) => (
    <div
        className={`${styles.expandable} ${expanded ? styles.expandableOpen : ''}`}
        onClick={expandOnClick(expanded, onToggle)}
    >
        <div className={styles.scroller}>
            <div className={`${styles.archive} ${expanded ? styles.archiveOpen : ''}`}>
                <ul className={styles.archiveWall}>
                    {archive.map(({ id, title, period, fields, summary, cover, url }) => (
                        <li key={id}>
                            <img
                                className={styles.archiveCover}
                                src={`${process.env.PUBLIC_URL}/${cover}`}
                                alt=""
                                loading="lazy"
                                draggable={false}
                            />
                            <p className={styles.archiveName}>{title}</p>
                            <p className={styles.archivePeriod}>{period}</p>
                            {expanded && (
                                <>
                                    <p className={styles.archiveSummary}>{summary}</p>
                                    <p className={styles.archiveFields}>{fields}</p>
                                    {url && <a className={styles.archiveLink} href={url}>사이트 보기</a>}
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        {!compact && <ExpandBar expanded={expanded} onToggle={onToggle} label="설명 보기" />}
    </div>
);

export default Archive;
